import { render, staticRenderFns } from "./AdvertsListItem.vue?vue&type=template&id=36d7501d&scoped=true&lang=pug&"
import script from "./AdvertsListItem.vue?vue&type=script&lang=js&"
export * from "./AdvertsListItem.vue?vue&type=script&lang=js&"
import style0 from "./AdvertsListItem.vue?vue&type=style&index=0&id=36d7501d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7501d",
  null
  
)

export default component.exports